import {ModuleComponent} from "../../js/module-component";

/**
 * Servicios "¿Cómo mejora Seion la eficacia?" (SEION).
 * Reveal por scroll con IntersectionObserver (seguro: el componente no
 * re-renderiza). Sin JS/IO o con reduced-motion, todo queda visible.
 */
export class ModAgentsFive extends ModuleComponent{

    ready(){
        super.ready();
        this.el = this.$root.get(0);
        if(!this.el) return;

        const items = Array.from(this.el.querySelectorAll(".js-item"));
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if(reduceMotion || !("IntersectionObserver" in window)){
            items.forEach(el => el.classList.add("is-in"));
            return;
        }

        // Activa el estado oculto sólo cuando el JS va a revelar (anti-invisible).
        this.el.classList.add("is-reveal");

        this.io = new IntersectionObserver((entries) => {
            entries.forEach(en => {
                if(en.isIntersecting){
                    en.target.classList.add("is-in");
                    this.io.unobserve(en.target);
                }
            });
        }, {threshold: .18, rootMargin: "0px 0px -6% 0px"});

        items.forEach(el => this.io.observe(el));
    }

    destroy(){
        if(this.io) this.io.disconnect();
        if(super.destroy) super.destroy();
    }
}
